<script>
    let {
        value,
        rowIndex,
        rowId,
        instructKey
    } = $props();

    let data = $derived(value);


    let targetUrl = $derived.by(() => {
        if (!data || !data.name || !data.kind) return "#";

        const type = data.target_object_type || "asset";
        const path = `/property/${type}/${encodeURIComponent(data.kind)}/${encodeURIComponent(data.name)}`;

        if (data.filters && Object.keys(data.filters).length > 0) {
            const queryStr = new URLSearchParams(data.filters).toString();
            return `${path}?${queryStr}`;
        }

        return path;
    });
</script>

{#if data && data.name}
    <a href={targetUrl} title="Ver">{data.name}</a>
{/if}